import React, { useState } from "react"
import { Space, Select, Input } from "antd"

const OtpFilters = ({ filters, onFiltersChange }) => {
    const [searchField, setSearchField] = useState("sentTo")
    const searchBy = (
        <Select defaultValue="sentTo" className="select-before" onChange={value => setSearchField(value)}>
            <Select.Option value="sentTo">Phone No</Select.Option>
        </Select>
    );

    return (
        <Space size="large">
            <div>
                Search :{` `}
                <Input.Search
                    addonBefore={searchBy}
                    placeholder="Search"
                    onSearch={term => onFiltersChange({ ...filters, sentTo: term, searchField })}
                />
            </div>
        </Space>
    );
}

export default OtpFilters;